module.exports = __webpack_public_path__ + "media/images/top/feature01-6b1d6600808fb6134e560c5f62deb747.jpg";